export default function totop() {
    const totopButton = document.querySelector('#js-totop');

    if (totopButton) {
        window.addEventListener('scroll', (e) => {
            e.preventDefault();

            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (scrollTop > 200) {
                totopButton.classList.add('totop--visible');
            } else {
                totopButton.classList.remove('totop--visible');
            }
        });

        totopButton.addEventListener('click', (e) => {
            e.preventDefault();

            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/Will/WebsiteBundle/Resources/ui/js/totop.js